import { useSelector } from "react-redux";
import { default as RootState } from "../types";
import { IError } from "./types";

export function useErrors(): IError[] {
  return useSelector((state: RootState) => state.error.errors);
}
